var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectoryConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 119 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1-directory-connected",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.5%",
    y: "-12.5%",
    width: "131.2%",
    height: "131.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2-directory-connected"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.733333333   0 0 0 0 0.733333333   0 0 0 0 0.733333333  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Data-Broker-Group-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Data-Broker-Group-Component-5",
    transform: "translate(-1016.000000, -760.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "for-keren-directories-svg",
    transform: "translate(1017.000000, 760.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-directories-new",
    transform: "translate(46.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2-directory-connected)",
    xlinkHref: "#path-1-directory-connected"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1-directory-connected"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_folder",
    transform: "translate(17.778443, 21.077844)",
    fill: "#1FA0FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9675097,6.32470588 L10.4684748,6.32470588 L9.20605846,3.94268405 C9.05665905,3.65717416 8.76137569,3.47793839 8.43914056,3.47706285 L1.18024656,3.47706285 C0.94732398,3.47504074 0.723322355,3.56662913 0.558614346,3.73133714 C0.393906342,3.89604514 0.302317947,4.12004675 0.304340065,4.35296935 L0.304340065,20.8346037 C0.302317947,21.0675263 0.393906342,21.2915279 0.558614346,21.456236 C0.723322355,21.6209439 0.94732398,21.7125323 1.18024656,21.7105102 L21.9659317,21.7105102 C22.1988542,21.7125323 22.4228559,21.6209439 22.5875639,21.456236 C22.7522719,21.2915279 22.8438603,21.0675263 22.8418382,20.8346037 L22.8418382,7.20050721 C22.837871,6.71842426 22.4480146,6.32856788 21.9659317,6.32470588 L21.9675097,6.32470588 Z",
    id: "Path_10057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4438887,2.84753787 L12.5759211,2.84753787 L11.3135048,0.465516026 C11.1641053,0.180006147 10.868822,0.000770372446 10.5465868,0 L4.08853821,0 C3.60484649,0 3.21273688,0.392109616 3.21273688,0.875801339 C3.21273688,1.35949306 3.60484649,1.75160268 4.08853821,1.75160268 L10.0297851,1.75160268 L11.2922015,4.13362453 C11.4416009,4.41913439 11.7368843,4.59837018 12.0591194,4.59914056 L24.5933357,4.59914056 L24.5933357,17.9334132 C24.5933356,18.2463069 24.7602624,18.5354326 25.0312363,18.6918794 C25.3022102,18.8483263 25.6360638,18.8483263 25.9070377,18.6918794 C26.1780116,18.5354326 26.3449383,18.2463069 26.3449383,17.9334132 L26.3449383,3.72333921 C26.31907,3.2401175 25.9253134,2.85839717 25.4415217,2.84753787 L25.4438887,2.84753787 Z",
    id: "Path_10058"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0.93,0.472 L0.93,39.472 L44.139,39.333",
    id: "Path_10143",
    stroke: "#006DC9",
    strokeWidth: 2,
    strokeDasharray: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectoryConnected);
export default __webpack_public_path__ + "static/media/directory-connected.dca8e73677683b76d4740105c4787d60.svg";
export { ForwardRef as ReactComponent };